module.exports = __webpack_public_path__ + "media/images/zalo_arrow-cffbea468bf526c64fca3514c1dae6e7.png";